module.exports = __webpack_public_path__ + "img/director.e35edb6f.svg";